export const getFirstName = (name) => {
  return name.split(" ")[0];
};
